export default __webpack_public_path__ + "static/bannerPubli-AR-6e1c6a4ab58f6d6121bccc82ee92bf8b.png";